export enum IPageStatus {
    statusA = 'statusA',
    statusB = 'statusB',
}
